export default __webpack_public_path__ + "static/media/pl-file.ff98fe7c.svg";